import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ViewportObserver from '@ynap/viewport-observer';
import DoubleImage from '../DoubleImage/DoubleImage';

class CombinedImage extends PureComponent {
    static propTypes = {
        aspectRatio: PropTypes.string,
        className: PropTypes.string,
        computeAttributes: PropTypes.bool,
        height: PropTypes.number,
        loading: PropTypes.bool,
        secondarySrc: PropTypes.string,
        src: PropTypes.string,
        width: PropTypes.number,
        xOffset: PropTypes.string,
        yOffset: PropTypes.string,
        displayError: PropTypes.bool,
        withIntersectionObserver: PropTypes.bool,
        imageSrcsetSize: PropTypes.string,
        ImageComponent: PropTypes.elementType,
        doubleImageWithoutPadding: PropTypes.string,
        doubleImageModifier: PropTypes.string,
    };

    render() {
        const {
            className,
            src,
            yOffset = '0px',
            xOffset = '0px',
            withIntersectionObserver = true,
            doubleImageWithoutPadding,
            doubleImageModifier,
        } = this.props;

        if (!withIntersectionObserver) {
            return (
                <DoubleImage
                    {...this.props}
                    className={className}
                    doubleImageWithoutPadding={doubleImageWithoutPadding}
                    doubleImageModifier={doubleImageModifier}
                />
            );
        }

        return (
            <ViewportObserver rootMargin={`0px ${xOffset} ${yOffset} 0px`} innerKey={src}>
                {(intersected) => (
                    <DoubleImage
                        {...this.props}
                        displaySrc={intersected}
                        className={className}
                        doubleImageWithoutPadding={doubleImageWithoutPadding}
                        doubleImageModifier={doubleImageModifier}
                    />
                )}
            </ViewportObserver>
        );
    }
}

export default CombinedImage;
